import { createI18n } from "vue-i18n";
import dateFormat from "./configs/dateFormat.json";

// Import des fichiers de langues
const importsJsonLang = {
  fr: import.meta.glob(`./locales/fr/*.json`, {eager: true}),
  en: import.meta.glob(`./locales/en/*.json`, {eager: true}),
  es: import.meta.glob(`./locales/es/*.json`, {eager: true}),
  de: import.meta.glob(`./locales/de/*.json`, {eager: true}),
  it: import.meta.glob(`./locales/it/*.json`, {eager: true}),
};

// Liste des langues importés
const localesI18n = Object.keys(importsJsonLang);

// Function to retrieve all messages
const getLocaleMessages = () => {
  const messages: Record<string, any> = {};
  localesI18n.forEach(locale => {
    messages[locale] = {};
    Object.values(importsJsonLang[locale]).forEach(module => {
      Object.assign(messages[locale], module.default);
    });
  });
  return messages;
};



const i18n = createI18n({
  locale: "fr",
  globalInjection: true,
  messages: getLocaleMessages(),
  datetimeFormats: {
    fr: {
      short: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
      longString: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long",
      },
      time : {
        hour : "2-digit",
        minute : "2-digit"
      },
      fulltime : {
        hour : "2-digit",
        minute : "2-digit",
        second : "2-digit"
      }
    },
    en: {
      short: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
      longString: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long",
      },
    },
  },
});

export default i18n;
